/**
 * WhatsApp link helpers
 * PURPOSE: Builds safe WhatsApp URLs and includes the complete property link in messages.
 *
 * EDIT HERE:
 * - Update the French message text below to change the default WhatsApp wording.
 * - Phone numbers are cleaned automatically, so spaces and plus signs are allowed in data.
 */

/**
 * Remove every non-numeric character because wa.me requires digits only.
 */
function normalizePhone(phone) {
  return String(phone || '').replace(/[^0-9]/g, '');
}

/**
 * Build the absolute public URL for one property.
 * Using `window.location.origin` keeps the link correct on localhost and on the live domain.
 */
export function getPropertyPublicUrl(propertyId) {
  if (!propertyId || typeof window === 'undefined') return '';
  return `${window.location.origin}/property/${propertyId}`;
}

/**
 * Build a property-specific WhatsApp link containing title, location, price and page URL.
 */
export function buildPropertyWhatsAppUrl(phone, property) {
  const cleanPhone = normalizePhone(phone);
  const propertyUrl = getPropertyPublicUrl(property?._id);
  const price = Number(property?.price);
  const lines = [
    'Bonjour, je suis intéressé(e) par ce bien :',
    property?.title ? `🏠 ${property.title}` : '',
    property?.location ? `📍 ${property.location}` : '',
    Number.isFinite(price) ? `💰 ${price.toLocaleString('fr-FR')} DT` : '',
    propertyUrl ? `🔗 ${propertyUrl}` : '',
  ].filter(Boolean);

  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(lines.join('\n'))}`;
}

/**
 * Build the general floating WhatsApp contact link used outside a specific property.
 */
export function buildGeneralWhatsAppUrl(phone) {
  const cleanPhone = normalizePhone(phone);
  return `https://wa.me/${cleanPhone}`;
}
